module.exports = __webpack_public_path__ + "static/img/2bg_20.6b7f082.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/2bg_20.png
// module id = 668
// module chunks = 1